module.exports = __webpack_public_path__ + "static/img/pdf-icon.9622102.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf-icon.png
// module id = F7RV
// module chunks = 1